export type Lang = 'fi' | 'en';

export const I18N = {
  fi: {
    feed: 'Syöte',
    analytics: 'Analytiikka',
    calendar: 'Kalenteri',
    live: 'Tallenna',
    record: 'Tallenna',
    search: 'Hae harjoituksia, lajeja, ihmisiä…',
    composer: 'Kirjaa harjoitus…',
    comments: 'kommenttia',
    forward: 'Välitä',
    forwarded: 'välitetty',
    kudos: 'peukkua',
    km: 'km',
    pace: 'tahti',
    time: 'aika',
    hr: 'syke',
    avgHr: 'ka. syke',
    etenema: 'etenemä',
    climb: 'nousu',
    reps: 'toistot',
    volume: 'volyymi',
    speed: 'vauhtinopeus',
    eventStream: 'Tapahtumavirta',
    mostForwarded: 'Kahden viikon välitetyimmät',
    thisWeek: 'Tämä viikko',
    weeklyVol: 'Viikkovolyymi',
    activities: 'Harjoitukset',
    sportSummary: 'Lajiyhteenveto',
    keywords: 'Avainsanat',
    weeks: 'Harjoitusviikot',
    groups: 'Ryhmät',
    distance: 'Matka',
    duration: 'Kesto',
    sessions: 'kertaa',
    records: 'Ennätykset',
    sportBreakdown: 'Lajijakauma',
    volumeTrend: 'Volyymi viikoittain',
    distanceTrend: 'Matka kuukausittain',
    hrZones: 'Sykealueet',
    consistency: 'Treenikalenteri',
    paceDist: 'Tahtijakauma',
    elevation: 'Korkeusprofiili',
    splits: 'Väliajat',
    total: 'Yhteensä',
    all: 'Kaikki',
    year: 'Vuosi',
    month: 'Kuukausi',
    week: 'Viikko',
    paused: 'Keskeytetty',
    recording: 'Tallennetaan',
    pause: 'Tauko',
    resume: 'Jatka',
    finish: 'Lopeta',
    lap: 'Kierros',
    current: 'Nykyinen',
    avg: 'Keskiarvo',
    cadence: 'Askeltiheys',
    power: 'Teho',
    gps: 'GPS',
    liveTitle: 'Iltalenkki',
    back: 'Takaisin',
    forwardedBy: 'välitti',
    loggedBy: 'kirjasi',
    minkm: 'min/km',
    kmh: 'km/h',
    bpm: 'bpm',
    spm: 'spm',
    m: 'm',
    w: 'W',
    you: 'Sinä',
    followers: 'seuraajaa',
    following: 'seurattua',
    logTitle: 'Kirjaa harjoitus',
    logSub: 'Lisää suoritus käsin',
    titleField: 'Otsikko',
    titlePh: 'Anna harjoitukselle nimi',
    sportField: 'Laji',
    moreSports: 'Lisää…',
    sportPicker: 'Valitse laji',
    sportSearch: 'Hae lajia…',
    durationField: 'Kesto',
    durationPh: 'esim. 1:06:42 tai 45min',
    distanceField: 'Matka',
    avgHrField: 'Keskisyke',
    paceField: 'Tahti',
    autoCalc: 'auto',
    dateField: 'Päivä',
    repsField: 'Toistot',
    volumeField: 'Volyymi',
    climbField: 'Nousu',
    intensityField: 'Miltä tuntui?',
    feelEasy: 'Kevyt',
    feelOk: 'Reipas',
    feelHard: 'Kova',
    keywordsPh: 'Lisää avainsana ja paina Enter',
    descField: 'Kuvaus',
    descPh: 'Miten meni? Reitti, keli, väliajat…',
    photoField: 'Kuva',
    photoPh: 'Pudota kuva tähän',
    save: 'Tallenna päiväkirjaan',
    cancel: 'Peruuta',
    preview: 'Esikatselu',
    previewHint: 'Näin se näkyy päiväkirjassasi',
    savedToast: 'Tallennettu päiväkirjaan',
    req: 'pakollinen',
    opt: 'valinnainen',
    writeMarkdown: 'Markdown',
    writeEditor: 'Editori',
    login: 'Kirjaudu sisään',
    logout: 'Kirjaudu ulos',
    profile: 'Profiili',
    diary: 'Päiväkirja',
    myDiary: 'Oma päiväkirja',
    noExercises: 'Ei harjoituksia',
    loadMore: 'Lataa lisää',
    showMore: 'Näytä lisää',
    showLess: 'Näytä vähemmän',
    deleteExercise: 'Poista harjoitus',
    editExercise: 'Muokkaa',
    confirmDelete: 'Haluatko varmasti poistaa tämän harjoituksen?',
    yes: 'Kyllä',
    no: 'Ei',
    commentPlaceholder: 'Kirjoita kommentti…',
    sendComment: 'Lähetä',
    kudosGiven: 'Antoi peukun',
    noComments: 'Ei kommentteja',
    gpxField: 'GPS-jälki (.gpx)',
    gpxDrop: 'Pudota .gpx-tiedosto tähän tai klikkaa',
    gpxLoaded: 'GPS-jälki ladattu',
    gpxRemove: 'Poista',
    gpxPoints: 'pistettä',
    gpxFilled: 'Matka, kesto ja nousu täytetty GPS-tiedoista',
    joinGroup: 'Liity',
    leaveGroup: 'Poistu',
    createGroup: 'Luo ryhmä',
    groupName: 'Ryhmän nimi',
    groupDesc: 'Kuvaus',
    editProfile: 'Muokkaa profiilia',
    saveProfile: 'Tallenna',
    profileSaveFailed: 'Profiilin tallennus epäonnistui. Tarkista arvot ja yritä uudelleen.',
    synopsisField: 'Esittely',
    restHr: 'Leposyke',
    maxHr: 'Maksimisyke',
    exportData: 'Vie tiedot',
    newComments: 'uutta kommenttia',
    noGroups: 'Ei ryhmiä',
    members: 'jäsentä',
  },
  en: {
    feed: 'Feed',
    analytics: 'Analytics',
    calendar: 'Calendar',
    live: 'Record',
    record: 'Record',
    search: 'Search activities, sports, people…',
    composer: 'Log a session…',
    comments: 'comments',
    forward: 'Forward',
    forwarded: 'forwarded',
    kudos: 'kudos',
    km: 'km',
    pace: 'pace',
    time: 'time',
    hr: 'HR',
    avgHr: 'avg HR',
    etenema: 'advance',
    climb: 'climb',
    reps: 'reps',
    volume: 'volume',
    speed: 'speed',
    eventStream: 'Activity stream',
    mostForwarded: 'Most forwarded · 2 weeks',
    thisWeek: 'This week',
    weeklyVol: 'Weekly volume',
    activities: 'Activities',
    sportSummary: 'Sport summary',
    keywords: 'Keywords',
    weeks: 'Training weeks',
    groups: 'Groups',
    distance: 'Distance',
    duration: 'Duration',
    sessions: 'sessions',
    records: 'Records',
    sportBreakdown: 'Sport breakdown',
    volumeTrend: 'Weekly volume',
    distanceTrend: 'Monthly distance',
    hrZones: 'Heart-rate zones',
    consistency: 'Training calendar',
    paceDist: 'Pace distribution',
    elevation: 'Elevation',
    splits: 'Splits',
    total: 'Total',
    all: 'All',
    year: 'Year',
    month: 'Month',
    week: 'Week',
    paused: 'Paused',
    recording: 'Recording',
    pause: 'Pause',
    resume: 'Resume',
    finish: 'Finish',
    lap: 'Lap',
    current: 'Current',
    avg: 'Average',
    cadence: 'Cadence',
    power: 'Power',
    gps: 'GPS',
    liveTitle: 'Evening run',
    back: 'Back',
    forwardedBy: 'forwarded',
    loggedBy: 'logged',
    minkm: 'min/km',
    kmh: 'km/h',
    bpm: 'bpm',
    spm: 'spm',
    m: 'm',
    w: 'W',
    you: 'You',
    followers: 'followers',
    following: 'following',
    logTitle: 'Log a session',
    logSub: 'Add a workout by hand — no app or device needed.',
    titleField: 'Title',
    titlePh: 'Name this session',
    sportField: 'Sport',
    moreSports: 'More…',
    sportPicker: 'Choose sport',
    sportSearch: 'Search sports…',
    durationField: 'Duration',
    durationPh: 'e.g. 1:06:42 or 45min',
    distanceField: 'Distance',
    avgHrField: 'Avg heart rate',
    paceField: 'Pace',
    autoCalc: 'auto',
    dateField: 'Date',
    repsField: 'Reps',
    volumeField: 'Volume',
    climbField: 'Ascent',
    intensityField: 'How did it feel?',
    feelEasy: 'Easy',
    feelOk: 'Moderate',
    feelHard: 'Hard',
    keywordsPh: 'Add keyword and press Enter',
    descField: 'Description',
    descPh: 'How did it go? Route, conditions, splits…',
    photoField: 'Photo',
    photoPh: 'Drop a photo',
    save: 'Save to diary',
    cancel: 'Cancel',
    preview: 'Preview',
    previewHint: 'This is how it appears in your diary',
    savedToast: 'Saved to your diary',
    req: 'required',
    opt: 'optional',
    writeMarkdown: 'Markdown',
    writeEditor: 'Editor',
    login: 'Sign in',
    logout: 'Sign out',
    profile: 'Profile',
    diary: 'Diary',
    myDiary: 'My diary',
    noExercises: 'No exercises yet',
    loadMore: 'Load more',
    showMore: 'Show more',
    showLess: 'Show less',
    deleteExercise: 'Delete exercise',
    editExercise: 'Edit',
    confirmDelete: 'Are you sure you want to delete this exercise?',
    yes: 'Yes',
    no: 'No',
    commentPlaceholder: 'Write a comment…',
    sendComment: 'Send',
    kudosGiven: 'gave kudos',
    noComments: 'No comments yet',
    gpxField: 'GPS trace (.gpx)',
    gpxDrop: 'Drop a .gpx file here or click to browse',
    gpxLoaded: 'GPS trace loaded',
    gpxRemove: 'Remove',
    gpxPoints: 'points',
    gpxFilled: 'Distance, duration and ascent filled from GPS data',
    joinGroup: 'Join',
    leaveGroup: 'Leave',
    createGroup: 'Create group',
    groupName: 'Group name',
    groupDesc: 'Description',
    editProfile: 'Edit profile',
    saveProfile: 'Save',
    profileSaveFailed: 'Saving the profile failed. Check the values and try again.',
    synopsisField: 'About',
    restHr: 'Resting HR',
    maxHr: 'Max HR',
    exportData: 'Export data',
    newComments: 'new comments',
    noGroups: 'No groups yet',
    members: 'members',
  },
} as const;

export type TranslationKey = keyof (typeof I18N)['en'];
